/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ now: NonNullable<unknown>, before: NonNullable<unknown> }} Workout_Highlights_Matched_VolumeInputs */

const en_us2_workout_highlights_matched_volume = /** @type {(inputs: Workout_Highlights_Matched_VolumeInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Volume: ${i?.now} (was ${i?.before})`)
};

const pt_br2_workout_highlights_matched_volume = /** @type {(inputs: Workout_Highlights_Matched_VolumeInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Volume: ${i?.now} (antes ${i?.before})`)
};

const es_419_workout_highlights_matched_volume = /** @type {(inputs: Workout_Highlights_Matched_VolumeInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Volumen: ${i?.now} (antes ${i?.before})`)
};

const pt_pt2_workout_highlights_matched_volume = /** @type {(inputs: Workout_Highlights_Matched_VolumeInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Volume: ${i?.now} (antes ${i?.before})`)
};

const fr_fr2_workout_highlights_matched_volume = /** @type {(inputs: Workout_Highlights_Matched_VolumeInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Volume : ${i?.now} (avant ${i?.before})`)
};

const de_de2_workout_highlights_matched_volume = /** @type {(inputs: Workout_Highlights_Matched_VolumeInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Volumen: ${i?.now} (vorher ${i?.before})`)
};

const it_it2_workout_highlights_matched_volume = /** @type {(inputs: Workout_Highlights_Matched_VolumeInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Volume: ${i?.now} (prima ${i?.before})`)
};

/**
* | output |
* | --- |
* | "Volume: {now} (was {before})" |
*
* @param {Workout_Highlights_Matched_VolumeInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const workout_highlights_matched_volume = /** @type {((inputs: Workout_Highlights_Matched_VolumeInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Workout_Highlights_Matched_VolumeInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_workout_highlights_matched_volume(inputs)
	if (locale === "es-419") return es_419_workout_highlights_matched_volume(inputs)
	if (locale === "pt-PT") return pt_pt2_workout_highlights_matched_volume(inputs)
	if (locale === "fr-FR") return fr_fr2_workout_highlights_matched_volume(inputs)
	if (locale === "de-DE") return de_de2_workout_highlights_matched_volume(inputs)
	if (locale === "it-IT") return it_it2_workout_highlights_matched_volume(inputs)
	return en_us2_workout_highlights_matched_volume(inputs)
});
export { workout_highlights_matched_volume as "workout-highlights.matched_volume" }